export default {"src":"/_next/static/media/monito-logo.d5b48ebe.svg","height":238,"width":568,"blurWidth":0,"blurHeight":0};